import trackSpellChanges from '../helpers/trackSpellChanges'
//-------------------------------
// process specific spell change
//-------------------------------
export default function processSpecificSpellChange({
  spell,
  original_spells,
  changed_spells,
  character,
}) {
  console.log('------------------------')
  console.log('IN processSpecificSpellChange')
  console.log('spell = ' + spell.name)
  //----------------------------------------------
  // track spell changes (performed in SpellCard)
  //----------------------------------------------
  changed_spells = trackSpellChanges({
    spell,
    original_spells,
    changed_spells,
    character_id: character.id,
  })
  console.log('QQQQQQQ changed_spells = ', changed_spells)
  //-----------------------
  // return changed spells
  //-----------------------
  return changed_spells
}
